import { useEffect, useState } from "react";
import axios, { apiBaseUrl } from "../../api/axios";
import { toast } from 'react-toastify';
import ResponsiveTable from "../../components/ResponsiveTable";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import ExportButtons from "../../components/ExportButtons";
import { useNavigate } from "react-router-dom";

export default function PageList() {
  const navigate = useNavigate();
  const [filtered, setFiltered] = useState([]);
  const getPageData = () => {
    axios.get("/roles/pages").then((res) => {
      setFiltered(res.data);
    });
  }
  useEffect(() => {
    getPageData()
  }, []);

  const capitalizeFirstLetter = (word) => {
    if (!word || typeof word !== "string") return word;
    return word.charAt(0).toUpperCase() + word.slice(1);
  };

  const actions = [
    { label: 'Edit', value: 'edit', icon: <PencilIcon className="w-4 h-4 inline" /> },
    { divider: true },
    { label: 'Delete', value: 'delete', icon: <TrashIcon className="w-4 h-4 inline text-red-600" /> },
  ];
  const handleActionClick = (action, row) => {
    switch (action) {
      case "edit":
        navigate(`/edit-page/${row.id}`);
        break;
      case "delete":
        if (window.confirm("Are you sure you want to delete this Page?")) {
          axios.delete(`/roles/pages/${row.id}`).then((res) => {
            toast.success(res.data.message || "Delete Page Successfully")
            getPageData()
          })
            .catch(err => toast.error(err.message || `Error`));
        }
        break;
      default:
        break;
    }
  };
  const handleDownload = (type) => {
    const url = `${apiBaseUrl}/purchases/export/${type}`;
    window.open(url, "_blank");
  };
  const columns = [
    { header: "SL", accessor: "sl", render: (v, row, i) => i + 1 },
    { header: "Page Name", accessor: "label" },
    {
      header: "Parent Page", accessor: "parent_label",
      render: (value, row) => <span className="">{value !== null ? value : "N/A"}</span>
    },
    { header: "Icon Name", accessor: "icon" },
    { header: "Page Path", accessor: "path" },

    { header: "Order", accessor: "order" },
    {
      header: "Show in Menu", accessor: "show_in_menu",
      render: (value, row) => <span className={value === 1 ? "text-green-800 font-semibold" : "text-red-600 font-semibold"}>{value === 1 ? "Yes" : "No"}</span>
    },
  ];

  return (
    <div className="p-4 max-w-6xl mx-auto text-sm bg-white rounded-md">
      <div className="w-full">
        <ExportButtons title="Pages List" onDownload={handleDownload} />
        <ResponsiveTable
          columns={columns}
          data={filtered}
          showActions
          actionButtons={actions}
          onActionClick={handleActionClick}
        />
      </div>
    </div>
  );
}